export default __webpack_public_path__ + "static/media/logo_MIC-300x300 Bailleur.cf7a21d8.png";